$(function() {
  var isDirectToConsumer = $('body').hasClass('dtc');

  if(isDirectToConsumer){
    $.getScript(ACC.config.commonResourcePath +"/js/analytics/analytics-dtc.js");
  }else{
    $.getScript(ACC.config.commonResourcePath +"/js/analytics/analytics.js");
  }
});
